import Vue from 'vue'
import TreeTable from '@/router/view/commercial/components/transaction-components/other-transaction-components/tree-table'

Vue.component('tree-table', TreeTable)
